(function () {
    "use strict";

    /**
     * Defines an HTTP interceptor which 
     *  - modifies template urls (the template urls should be relative to the templates folder)
     *  - injects a GET parameter to ensure a reload is done when a new version is deployed
     */
    angular.module("app").factory("templateResolver", TemplateResolverFactory);

    TemplateResolverFactory.$inject = ["settingsService", "versionTimestamp"];
    function TemplateResolverFactory(settingsService, versionTimestamp) {
        return {
            'request': function (config) {

                // IMPORTANT: To apply the habil convention we require that:
                //  - The templateUrl starts with @/, this is an explicit identifier for templates which should be handled
                //  - The request actually requests a template (all $http requests invoke this interceptor)
                const isHabilTemplateRequest = config.url.startsWith("@/") && config.url.toLowerCase().indexOf('.html') !== -1;

                if (isHabilTemplateRequest) {
                    config.url = `${settingsService.applicationPath}app/templates/${config.url.substring(2)}?v=${versionTimestamp}`;
                }
                return config;
            }
        };
    }
})();